import { useBatchDraftPersistenceCore } from '@pantry/shared-react/hooks';
import {
  useBatchEntryStore,
  getPendingDraft,
  clearPendingDraft,
} from '../stores/batch-entry-store';

/**
 * Hook to manage batch draft persistence and recovery.
 * Checks for existing drafts on mount and provides functions
 * to resume or discard them.
 *
 * @example
 * ```tsx
 * const { hasPendingDraft, pendingDraftCount, resumeDraft, discardDraft } = useBatchDraftPersistence();
 *
 * if (hasPendingDraft) {
 *   return <ResumeDraftBanner count={pendingDraftCount} onResume={resumeDraft} onDiscard={discardDraft} />;
 * }
 * ```
 */
export function useBatchDraftPersistence() {
  const { isActive, importDraft, draftItems } = useBatchEntryStore();
  return useBatchDraftPersistenceCore({
    isActive,
    draftItemCount: draftItems.length,
    getPendingDraft,
    clearPendingDraft,
    importDraft,
  });
}
